angular.module('wbDirectives').directive 'wbTableFixed', ->
  restrict: 'A'
  link: ($scope, $el, $attrs) ->
    $spacer = $($el[0].outerHTML)
    $el.after($spacer)
    $spaces = $spacer.children('th')
    setTimeout ->
      $el.find('th > div').width (i, currentWidth) ->
        width = $($spaces[i]).width()
        return width if width > 0
        currentWidth
      , 1000
